export default "__VITE_ASSET__4d8e8304__"